import { Money, useCart } from "@shopify/hydrogen";
import { translate } from "@locales";

function useOrderSummary() {
  const { cost } = useCart();

  const subtotalAmount = cost?.subtotalAmount;
  return {
    models: {
      cost,
      subtotalAmount,
    },
    operatiosn: {},
  };
}

export function OrderSummary() {
  const { models } = useOrderSummary();
  return (
    <>
      <dl className="space-y-2">
        <div className="flex items-center justify-between">
          <dt className="font-chivo-bold text-xl tracking-widest">
            {translate("shop.checkoutAction.subtotal")}
          </dt>
          <dd className="font-chivo-regular text-custom-dark-blue bold text-xl">
            {models.cost?.subtotalAmount?.amount ? (
              <Money data={models.cost?.subtotalAmount} />
            ) : (
              "-"
            )}
          </dd>
        </div>
        <div className="flex items-center justify-between font-chivo-light">
          <dt className="flex items-center">
            <span>{translate("shop.checkoutAction.taxes")}</span>
          </dt>
          <dd>{translate("shop.checkoutAction.calculate-at-checkout")}</dd>
        </div>
        <div className="flex items-center justify-between font-chivo-light">
          <dt className="flex items-center">
            {translate("shop.checkoutAction.estimated-shipping")}
          </dt>
          <dd>{translate("shop.checkoutAction.calculate-at-checkout")}</dd>
        </div>
      </dl>
    </>
  );
}
